// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';
// import i18next from 'i18next';
// import { AFEViewModal } from './assignedFEModal';

// export const FEComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('fe.slNo'), width: 20 },
//     { id: 'nameOfFE', field: 'nameOfFE', headerName: t('fe.nameOfFE'), width: 50 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: t('fe.links'),
//       width: 100,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           {t('fe.viewDetails')}
//         </a>
//       ),
//     },
//   ];

//   useEffect(() => {
//     axios.get(
//       // `${API_BASE_URL}/home-notification/fe/`)
//       `${API_BASE_URL}/home-notification/assignedfe/` , {params: { language: i18next.language }})
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           nameOfFE: item.name_of_fe,
//           links: item.link,
//         }));
//         setRows(apiData);
//         setSnackbarMessage(t('fe.successMessage'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch Financial Establishments data:', error);
//         setSnackbarMessage(t('fe.errorMessage'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, [t]);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('fe.heading')}
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//         <AFEViewModal
//               open={viewModalOpen}
//               onClose={handleCloseModal}
//               selectedItem={selectedItem}
//               modalLoading={modalLoading}
//               formatList={formatList}
//             />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Box, Typography, IconButton } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { AFEViewModal } from './assignedFEModal';

export const FEComponent = () => {
  const { t, i18n } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  // ✅ Modal state
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('fe.slNo'), width: 60 },
    { id: 'nameOfFE', field: 'nameOfFE', headerName: t('fe.nameOfFE'), width: 300 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: t('fe.links'),
      width: 120,
      renderCell: (params) => (
        <IconButton
          size="small"
          color="primary"
          onClick={() => handleViewDetails(params.row)}
        >
          <Visibility />
        </IconButton>
      ),
    },
  ];

  // ✅ FIXED: Language-aware fetch with useCallback
  const fetchFEData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`, {
        params: { language: i18n.language }
      });
      
      const apiData = response.data.map((item, index) => ({
        id: item.id || index,
        slNo: index + 1,
        nameOfFE: item.name_of_fe,
        links: item.link,
      }));
      
      setRows(apiData);
      setSnackbarMessage(t('fe.successMessage'));
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Failed to fetch Financial Establishments data:', error);
      setSnackbarMessage(t('fe.errorMessage'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, [t, i18n.language]);

  // ✅ Language change detection
  useEffect(() => {
    fetchFEData();
  }, [fetchFEData]);

  // ✅ Handle View Details - Opens modal with full data
  const handleViewDetails = async (row) => {
    setModalLoading(true);
    try {
      // Fetch full details for the selected item
      const response = await axios.get(
        `${API_BASE_URL}/home-notification/assignedfe/${row.id}/`, 
        { params: { language: i18n.language } }
      );
      setSelectedItem(response.data);
      setViewModalOpen(true);
    } catch (error) {
      console.error('Failed to fetch details:', error);
      setSnackbarMessage(t('fe.errorMessage'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setModalLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCloseModal = () => {
    setViewModalOpen(false);
    setSelectedItem(null);
  };

  const formatList = (text) => {
    if (!text) return '-';
    return text.split(/[\d]\.\s+/).filter(item => item.trim()).map((item, index) => 
      `${index + 1}. ${item.trim()}`
    ).join('\n');
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" bgcolor="rgba(195, 234, 203, 0.1)" mb={2} p={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('fe.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus={true}
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      {/* ✅ Modal - Opens on eye icon click */}
      <AFEViewModal
        open={viewModalOpen}
        onClose={handleCloseModal}
        selectedItem={selectedItem}
        modalLoading={modalLoading}
        formatList={formatList}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
